window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
    // addToCartRedirect: ({ cartItems, discountCode }) => {
    //   localStorage.setItem("navigatedToCheckout", JSON.stringify(cartItems));
    //   const openCartEvent = new Event("reloadCartAndOpen", { cartItems, discountCode });
    //   window.dispatchEvent(openCartEvent);
    //   window.location.assign(`/discount/${discountCode}?redirect=/checkout`);
    // }
  },
});

// Registers each cart bundle item's remove button
document.body.addEventListener("click", async (event) => {
  if (
    !event.target.matches(
      ".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]"
    )
  )
    return;
  const bundleElement =
    event.target.closest("a.cart__remove-bundle") ||
    (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement
    ? bundleElement.getAttribute("data-bundle-id")
    : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce(
          (acc, item) =>
            item.properties?._bundleUid == bundle_id
              ? { ...acc, [item.key]: 0 }
              : acc,
          {}
        ),
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

const isBab = window.location.pathname.includes(
  "/tools/bundle-subscriptions/bundle/"
);
if (isBab) {
  let progressContainer = 0;

  const getBabSelection = function () {
    let preselection = { items: [] };

    document.querySelectorAll('[data-testid="product-card"]').forEach((e) => {
      let quantity = parseInt(
        e.querySelector(
          ".bundle-product-card__quantity-button-container > span"
        ).textContent
      );
      let id = e.dataset.pid;
      for (let i = 0; i < quantity; i++) {
        preselection.items.push(id);
      }
    });

    setPreselection(preselection);
  };

  const updateProgressBar = () => {
    const progressBar = document.querySelector("div.customProgressBar");
    const items = document.querySelectorAll(
      ".awtomatic-progress-container > *"
    );
    const completed = document.querySelectorAll(
      ".awtomatic-progress-container > .awtomatic-progress-item--completed"
    );
    progressBar.textContent = `${completed.length} of ${items.length} items selected`;
  };

  const progressObs = new MutationObserver(() => {
    const currentLength = document.querySelector(
      ".awtomatic-progress-container"
    )?.children?.length;
    if (currentLength && currentLength !== progressContainer) {
      progressContainer = currentLength;
      progressObs.disconnect();

      const container = document.querySelector(
        ".bundle-container > footer > div"
      );
      const progressBar = document.createElement("div");
      progressBar.className = "customProgressBar";
      container.appendChild(progressBar);

      const observer = new MutationObserver((mutations, obs) => {
        if (!isProcessingPreselection) {
          updateProgressBar();
          getBabSelection();
        }
      });

      const progressContainerElement = document.querySelector(
        ".awtomatic-progress-container"
      );
      if (progressContainerElement) {
        observer.observe(progressContainerElement, {
          childList: true,
          subtree: true,
        });
        updateProgressBar();
      }
    }
  });
  progressObs.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  const setPreselection = (preselection) =>
    localStorage.setItem("preselection", JSON.stringify(preselection));
  const getPreselection = () =>
    localStorage.getItem("preselection") &&
    localStorage.getItem("preselection") !== "undefined"
      ? JSON.parse(localStorage.getItem("preselection"))
      : undefined;
  const preselection = getPreselection();

  let isProcessingPreselection = false;

  const allReadyHandler = () => {
    if (preselection && preselection.items && preselection.items.length) {
      isProcessingPreselection = true;
      preselection.items.forEach((item, index) => {
        setTimeout(() => {
          const parent = document.querySelector(
            `.bundle-product-card[data-pid="${item}"]`
          );
          if (parent) {
            const selectedBtn = parent.querySelector(
              'button[data-testid="increment-quantity"]'
            );
            if (selectedBtn) {
              selectedBtn.click();
            } else {
              console.log(`${item} not available`);
            }
          } else {
            console.log(`${item} not found`);
          }
          // Check if it's the last iteration
          if (index === preselection.items.length - 1) {
            isProcessingPreselection = false;
            updateProgressBar();
            getBabSelection();
          }
        }, 10 * index);
      });
      if (preselection.type) {
        const preselMsg = document.createElement("div");
        preselMsg.classList.add("preselMsg");
        preselMsg.innerText =
          "We've pre-selected our top sellers for you. Scroll down to customize the box using the +/- buttons";
        document
          .querySelector(".awt-bab-open main.bundle-create-content")
          .prepend(preselMsg);
      }
    }

    document
      .querySelectorAll(".bundle-product-card__quantity-button-container")
      .forEach((container) => {
        container.addEventListener("click", (e) => {
          const parentDiv = e.target.closest('div[id^="section-"]');

          if (
            parentDiv &&
            parentDiv.classList.contains("awt-is-max-size-reached")
          ) {
            const tooltip = document.createElement("div");
            tooltip.textContent =
              "You have reached the max amount of Premium cuts, scroll down to fill your box with other items";
            tooltip.style.position = "absolute";
            tooltip.style.backgroundColor = "black";
            tooltip.style.color = "white";
            tooltip.style.padding = "5px";
            tooltip.style.borderRadius = "5px";

            tooltip.style.top = `${
              e.target.offsetTop + e.target.offsetHeight
            }px`;
            tooltip.style.left = `${e.target.offsetLeft}px`;

            tooltip.style.zIndex = "99";

            setTimeout(() => {
              tooltip.remove();
            }, 3000);

            const bundleContainer = parentDiv.closest(".bundle-container");

            if (
              bundleContainer &&
              bundleContainer.getAttribute("pid") === "8058379468938" &&
              bundleContainer.getAttribute("vid") === "44801303838858"
            ) {
              const currentSellingPlan = new URLSearchParams(
                window.location.search
              ).get("selling_plan");
              const link = document.createElement("a");
              link.href = `/tools/bundle-subscriptions/bundle/8058379468938?variant=44801303871626&selling_plan=${currentSellingPlan}`;
              link.textContent =
                "You have reached the maximum selections for this section. Click here to upgrade to the Family box size and select more.";
              tooltip.textContent = "";
              tooltip.appendChild(link);
            }

            e.target.appendChild(tooltip);
          }
        });
      });
  };

  const preselObs = new MutationObserver(() => {
    const currentLength = document.querySelectorAll(
      ".bundle-product-card"
    ).length;
    if (currentLength > 0) {
      preselObs.disconnect();
      allReadyHandler();
    }
  });
  preselObs.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  const checkFromCheckout = async () => {
    const getNavigatedToCheckout = () =>
      localStorage.getItem("navigatedToCheckout") &&
      localStorage.getItem("navigatedToCheckout") !== "undefined"
        ? JSON.parse(localStorage.getItem("navigatedToCheckout"))
        : undefined;
    const navigatedToCheckout = getNavigatedToCheckout();

    if (navigatedToCheckout) {
      try {
        // Get current cart contents
        const cart = await (await fetch("/cart.js")).json();

        // Create data object for cart update AJAX call
        const data = {
          updates: cart.items.reduce(
            (acc, item) =>
              navigatedToCheckout.some(
                (ncItem) =>
                  ncItem.properties._bundleUid === item.properties?._bundleUid
              )
                ? { ...acc, [item.key]: 0 }
                : acc,
            {}
          ),
        };

        // API call to update the cart contents and set the bundle item quantities to 0
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
      } catch (error) {
        console.error(error);
      }
    }
    localStorage.removeItem("navigatedToCheckout");
  };
  window.addEventListener("focus", function (event) {
    checkFromCheckout();
  });
  checkFromCheckout();
}
